export function Spinner({ label = 'Lädt …' }: { label?: string }) {
  return <span className="spinner" role="status" aria-label={label} />;
}

// PageLoader: Platzhalter in der Form des kommenden Inhalts statt eines Kreisels; der Text bleibt für Screenreader.
export function PageLoader({ label = 'Lädt …', lines = 3 }: { label?: string; lines?: number }) {
  return (
    <div className="page-loader skeleton" role="status" aria-label={label}>
      {Array.from({ length: lines }, (_, i) => (
        <span key={i} className="skeleton-line" aria-hidden="true" />
      ))}
      <span className="visually-hidden">{label}</span>
    </div>
  );
}

export function FullPageLoader({ label = 'Lädt …' }: { label?: string }) {
  return (
    <div className="center-page">
      <div className="page-loader">
        <Spinner label={label} />
        <span className="muted">{label}</span>
      </div>
    </div>
  );
}
